// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable */

const initPixel = (id: string): void => {
  if (typeof fbq === "undefined") {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js",
    );
    fbq("init", id);
  }
};

/**
 * Initialize Facebook pixel and fire the PageView event.
 * @param id
 */
export const initFacebook = (id: string): void => {
  if (typeof fbq === "undefined") {
    initPixel(id);
    fbq("track", "PageView");
  }
};

/**
 *
 * @param id
 * @param event
 * @param ldu
 * @param eventID
 */
export const sendFacebookEvent = (
  id: string,
  event: string,
  ldu: boolean | undefined,
  eventID: string,
): void => {
  if (typeof fbq === "undefined") {
    initPixel(id);
    if (ldu) {
      fbq("dataProcessingOptions", ["LDU"], 1, 1000);
    } else {
      fbq("dataProcessingOptions", []);
    }
    fbq("track", "PageView");
  }
  if (event) {
    fbq(
      "trackSingleCustom",
      id,
      event,
      { currency: "USD", value: 0 },
      { eventID },
    );
  }
};
